module.exports = __webpack_public_path__ + "static/media/info-circle.229c48b6.svg";